import { ReactElement } from "react";
import CircleCheck from "../../assets/CheckCircle.svg";
import { IconWithLabel, Link } from "../Actions";
import { DiscordBanner } from "../DiscordBanner/DiscordBanner";
import { StepContent } from "../NetworkMint/Steps/Components";

type MintSuccessProps = {
  discordMessage?: string | ReactElement;
  description: string | ReactElement;
  id?: string;
};
export const MintSuccess: React.FC<MintSuccessProps> = ({
  description,
  discordMessage,
  id
}) => {
  return (
    <section
      className="flex items-center flex-col mt-8 max-w-6xl mx-auto px-4"
      id={id}>
      <CircleCheck className="text-coinage-teal" width="50" />
      <StepContent title="Success!" description={description}>
        <Link href="/" analyticsProperty="back to home" modifier="primary">
          <IconWithLabel label="Back to Home" icon="arrow" />
        </Link>
        {discordMessage && <DiscordBanner>{discordMessage}</DiscordBanner>}
      </StepContent>
    </section>
  );
};
